<div class="no-services">You have no services.</div>
<div class="no-services">
  Click the <strong>'+'</strong> button in the bottom right corner to add a
  service.
</div>
